module.exports = __webpack_public_path__ + "static/media/eurogenco.bc6e65eb.png";